import { inject, injectable } from 'inversify';
import { ArmyListFormatedMapper } from '@Mapper/builder/import/army-list-formated.mapper';
import { TYPES } from '@Types';
import { RequestAction, RequestFailure } from '../RequestAction';
import { RequestArmyListFormatedSuccess } from './response';
import { ApiClient } from '@Api';
import { Locale } from '../locale';
import { Nullable } from '@Models';

@injectable()
export class FormatRepository {
  @inject(TYPES.Locale) protected _locale!: Locale;
  @inject(TYPES.Mapper.ArmyListFormatedMapper)
  private _armyListFormatedMapper!: ArmyListFormatedMapper;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;

  private _key: string = '/builder/formattings';

  public async format({
    date,
    game,
    source,
    locale,
  }: {
    date: number;
    game: string;
    source: string;
    locale: Nullable<string>;
  }): Promise<RequestAction> {
    try {
      const armyListDto = await this._apiClient.builder.formatArmyListText({
        locale: locale ?? this._locale.getlocale(),
        date: date,
        game: game,
        requestBody: {
          data: source,
        },
      });
      return new RequestArmyListFormatedSuccess({
        payload: this._armyListFormatedMapper.map(armyListDto),
      });
    } catch (error: any) {
      return new RequestFailure({ error: error });
    }
  }

  protected getKey({ locale }: { locale: Nullable<string> }): RequestInfo {
    return `/${locale ?? this._locale.getlocale()}${this._key}`;
  }
}
